export default __webpack_public_path__ + "static/media/mixkit-correct-answer-tone-2870.a673b70c.wav";